
<div class="row text-center">
    <div class="col">
        
        <h1 class="title-copy signup-fs-ls">{{ "ACCOUNT_ACTIVATION" | translate }}</h1>
        <div class="text-center" [ngClass]="{'margin-bottom mb24 policy-acct-txt-color' : !isAcmic}">
            <p>{{"NO_PHONE_NO_EMAIL_CONTEXT" | translate }}
            </p>
        </div>
        <form [formGroup]="accountVerificationForm" name="accountVerificationForm"
         (ngSubmit)="accountVerificationForm.valid && validateNoPhoneNoEmail()"
            class="s-signUpForm">
            <div class="input text-left">
                <div *ngFor="let input of inputs; index as index; " class="input">
                    <mapfre-validation [input]="input" [form]="accountVerificationForm"></mapfre-validation>
                </div>
            </div>
            <div class="row group-button text-center">
                <div class="col">
                  <mapfre-button [ngClass]="{'custom_loader':loader}"
                    [additionalClasses]="'basic primary large-btn'"
                    [disabledValue]="accountVerificationForm.valid && !loader"
                    [inputType]="'submit'"
                    [translateValue]="'CONTINUE' | translate"
                  ></mapfre-button>
                </div>
              </div>              
        </form>
        <div class="row margin-top mt24" *ngIf="!isAcmic">
          <div class="col text-center policy-acct-txt-color">
            <div>If you need help, please </div>
            <div>contact our Customer Service department.</div>
            <div class="margin-top mt8">
              <a href="tel:{{ 'CUSTOMER_SERVICE_NUMBER' | translate }}" class="mapfre link red-link underline fs-16">
                {{ "CUSTOMER_SERVICE_NUMBER" | translate }}
              </a>
            </div>
          </div>
        </div>
        <div class="row margin-top mt24 text-center checkingrowbtm">
            <div class="col">
              <mapfre-button
                (click)="goBack()"
                additionalClasses="link-button small-btn red-link no-margin button-border-red"
                [backIcon]="'assets/img/icons/back-arrow-red.png'"
                [iconClasses]="'align-middle'"
                [showIconsCustom]="true"
              >
                {{ "BACK" | translate }}
              </mapfre-button>
            </div>
          </div>
    </div>